import { render, staticRenderFns } from "./w-tab-bar.vue?vue&type=template&id=2c472345&scoped=true&"
import script from "./w-tab-bar.vue?vue&type=script&lang=js&"
export * from "./w-tab-bar.vue?vue&type=script&lang=js&"
import style0 from "./w-tab-bar.vue?vue&type=style&index=0&id=2c472345&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c472345",
  null
  
)

export default component.exports